import React from 'react'
import { observer } from 'mobx-react'
import JobViewModel from '../JobViewModel'
import { Card, CardContent, CardHeader, CardTitle } from 'components/Card'
import ProgressBar from 'components/ProgressBar'
import Button from 'components/Button'

interface Props {
  vm: JobViewModel
}

export default observer(function CompleteOnboardingCard({ vm }: Props) {
  React.useEffect(() => {
    vm.detailsVM.completeOnboarding.set(true)
  }, [vm.detailsVM.completeOnboarding])

  return (
    <Card dataTest="complete-onboarding-card">
      {vm.questionsCompleted ? (
        <>
          <CardHeader>
            <CardTitle>Review and submit</CardTitle>
          </CardHeader>
          <CardContent>
            <ProgressBar
              bars={[{ progress: 50 }, { progress: 50, style: 'striped' }]}
            />
          </CardContent>
          <CardContent>Review responses and submit the job.</CardContent>
          <CardContent>
            <Button
              type="primary"
              block
              onClick={vm.submitJobDialogVM.show}
              dataTest="complete-onboarding-card-submit-button"
            >
              Submit Job
            </Button>
          </CardContent>
        </>
      ) : (
        <>
          <CardHeader>
            <CardTitle>Complete onboarding</CardTitle>
          </CardHeader>
          <CardContent>
            <ProgressBar key={1} bars={[{ progress: 50, style: 'striped' }]} />
          </CardContent>
          <CardContent>
            Capture all outstanding responses to proceed with the job.
          </CardContent>
          <CardContent>
            <Button
              block
              type="primary"
              onClick={vm.editDraft}
              dataTest="complete-onboarding-card-edit-responses-button"
            >
              Edit Responses
            </Button>
          </CardContent>
        </>
      )}
    </Card>
  )
})
